import React, { useEffect, useState } from 'react';
import EfImg from '@elem/ui/ef-img';
import classNames from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';
import { Pagination, Navigation } from 'swiper';

export type EfAccordionCardType = {
    pc: string;
    pad?: string;
    h5?: string;
    title: string;
    desc: string;
};

export interface EfAccordionCardsProps {
    className?: string;
    list: EfAccordionCardType[];
    type?: 'default' | 'page';
}

/**
 * 维护:Hzihhuang（黄子豪）
 *
 * 手风琴「卡片」组件
 */
const EfAccordionCards: React.FC<EfAccordionCardsProps> = ({ className, list, type = 'default' }) => {
    const prefixCls = `ef-accordion-cards`;

    const [activeIdx, setActiveIdx] = useState(0);

    const [isH5, setIsH5] = useState(false);
    useEffect(() => {
        setIsH5(window.innerWidth <= 768);
    }, []);

    return (
        <div>
            <Swiper
                className={classNames(prefixCls, className, type)}
                slidesPerView={'auto'}
                modules={[Pagination, Navigation]}
                loop={type === 'page' && isH5}
                pagination={{
                    el: `.${prefixCls}-pagination`,
                    clickable: true,
                }}
                navigation={{
                    nextEl: `.${prefixCls}-btn-next`,
                    prevEl: `.${prefixCls}-btn-prev`,
                }}
            >
                {list.map((item, idx) => (
                    <SwiperSlide
                        className={classNames(`${prefixCls}-item`, { active: activeIdx === idx })}
                        key={`${item.title}-${idx}`}
                        onMouseEnter={() => {
                            setActiveIdx(idx);
                        }}
                    >
                        <EfImg pc={item.pc} pad={item.pad} h5={item.h5} />
                        <div className={`${prefixCls}-info`}>
                            <div className={`${prefixCls}-title`}>{item.title}</div>
                            <div className={classNames(`${prefixCls}-desc`)}>{item.desc}</div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            {type === 'page' && (
                <div className={`${prefixCls}-navigation`}>
                    <div className={`${prefixCls}-btn-prev ${prefixCls}-btn`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                            <path d="M7 1L1 7L7 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                    <div className={`${prefixCls}-pagination`}></div>
                    <div className={`${prefixCls}-btn-next ${prefixCls}-btn`}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                            <path d="M1 1L7 7L0.999999 13" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </div>
                </div>
            )}
        </div>
    );
};
export default EfAccordionCards;
